module.exports = __webpack_public_path__ + "static/media/1.b425c9d4.jpg";